import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  trackProjectExported,
  deriveProjectType,
} from '@src/services/moengage';

// Fills project identity from redux so callers only pass export specifics.
const useTrackProjectExported = () => {
  const product = useSelector((state) => state.project.product);
  const source = useSelector((state) => state.project.source);

  return useCallback(
    (attrs) =>
      trackProjectExported({
        projectType: deriveProjectType({ product, source }),
        ...attrs,
      }),
    [product, source],
  );
};

export default useTrackProjectExported;
